import { CommonModule } from '@angular/common';
import {
  Component,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { Subscription } from 'rxjs';

import {
  ConfirmModalService,
  IConfirmModalSettings,
} from './confirm-modal.service';

@Component({
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.css'],
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule],
})
export class ConfirmModalComponent implements OnInit, OnDestroy {
  @ViewChild('confirmTmp')
  confirmTmp: TemplateRef<any>;

  private subscribes: Subscription[] = [];

  constructor(
    private dialog: MatDialog,
    private confirmModalService: ConfirmModalService,
  ) {}

  ngOnInit(): void {
    this.subscribes.push(
      this.confirmModalService.confirm.subscribe(this.openConfirm),
    );
  }

  ngOnDestroy(): void {
    this.subscribes.forEach((s) => s.unsubscribe());
  }

  openConfirm = (config: IConfirmModalSettings) => {
    this.dialog
      .open(this.confirmTmp, {
        data: config,
        width: config.width,
      })
      .afterClosed()
      .subscribe((result: boolean) => {
        if (result) {
          config.confirmAction();
        } else if (config.rejectAction) {
          config.rejectAction();
        }
      });
  };
}
